import { __awaiter, __generator } from "tslib";
import { AuthError } from '@azure/msal-browser';
import { fetchIdentity, getOfficeIdentity, } from '@office-start/identity-service';
import { getToken } from './getToken';
import { redirectToLogin } from './redirectToLogin';
// Every 1 hour, refresh the OfficeHome token in the background. If the refresh fails (the refresh token was revoked for some reason, or not meeting Conditional Access policy),
// then we need to redirect the user to login to get a new refresh token.
export function setupOfficeHomeTokenRefresh() {
    var _this = this;
    window.setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
        var result, identityResult, identity, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getToken({
                        tokenConsumer: 'OfficeHome',
                        forceFetch: true,
                    })];
                case 1:
                    result = _b.sent();
                    if (result.success) {
                        return [2 /*return*/];
                    }
                    if (!(result.error instanceof AuthError && result.error.errorCode)) return [3 /*break*/, 5];
                    identityResult = getOfficeIdentity();
                    if (!identityResult) return [3 /*break*/, 2];
                    _a = identityResult;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, fetchIdentity()];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    identity = _a;
                    // OfficeHome token fetch failed due to an auth error. Need to relogin to get new refresh token.
                    redirectToLogin(identity, 'OfficeHomeRefreshFailed', {
                        IdentityIssuedTime: identity.identityIssuedTimeUnixMs || -1,
                        ErrorResult: result.error.toString(),
                    });
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); }, 1 * 55 * 60 * 1000 /* 55 minutes. Use a 5 minute buffer to avoid refreshing the token right when it expires. */);
}
//# sourceMappingURL=setupOfficeHomeTokenRefresh.js.map